import NumberFormats from "components/NumberFormats";
import React from "react";
import { Typography } from "@mui/material";

function WrapperDepositWithdraw({ data }) {
  return (
    <Typography
      variant="h6"
      fontWeight={600}
      color={
        data.valueDepositWithdraw > 0
          ? "success.main"
          : data.valueDepositWithdraw < 0
          ? "error.main"
          : "text.main"
      }
    >
      {data.valueDepositWithdraw > 0 && "+"}
      <NumberFormats value={data.valueDepositWithdraw} />
    </Typography>
  );
}

export default WrapperDepositWithdraw;
